import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {InputSwitch} from "primereact/inputswitch";
import axios from "axios";
import PartnerContactsComponent from "../partner/PartnerContactsComponent";
import WorkflowactionListComponent from "./WorkflowactionListComponent";

const WorkflowFormComponent = (props) => {

  //form
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const validate = (data) => {
    let errors = {};
    // if (!data.name) {
    //   errors.name = 'Az megnevezés nem lehet üres';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    setFormData({
      ...formData,
      data
    });
    if ((window.App.state.propsWorkflow && window.App.state.propsWorkflow !== null) || formData.id) {
      axios({
        method: 'put',
        url: process.env.REACT_APP_API_HOST + '/workflow/' + window.App.state.propsWorkflow.id,
        data: data,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          setFormData(response.data)
          window.App.toastShow('success', 'Sikeres módosítás!');
          window.App.setState({
            rerenderWorkflowList: true,
          })
          if (props.closeForm === true) {
            window.App.setState({
              sidebarWorkflowUpdate: false,
            })
          }
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    } else {
      axios({
        method: 'post',
        url: process.env.REACT_APP_API_HOST + '/workflow',
        data: data,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          setFormData(response.data)
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({
            rerenderWorkflowList: true,
          })
          if (props.closeForm === true) {
            window.App.setState({
              sidebarWorkflowCreate: false,
            })
          }
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  useEffect(() => {
    if (window.App.state.propsWorkflow) {
      setFormData(
        window.App.state.propsWorkflow
      )
    }
  }, [])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit}) => (
      <form onSubmit={handleSubmit} className="">
        <Panel headerTemplate={
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-list"}></i> Alapadatok
              </h3>
            </div>
          </div>
        } className={""}>
          <div className={"p-grid"}>
            {/*<div className={"p-col-12 p-lg-2"}>*/}
            {/*  <Field name="active" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="active"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>Aktív</label>*/}
            {/*      <span className="p-d-block">*/}
            {/*        <InputSwitch*/}
            {/*          className={"p-mt-1"}*/}
            {/*          checked={formData.active}*/}
            {/*          value={formData.active}*/}
            {/*          onChange={e => setFormData({...formData, active: e.target.value})}/>*/}
            {/*      </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            <div className={"p-col-12 p-lg-12 p-xl-12"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>Megnevezés</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-3"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
              <Button type="submit" label="Mentés és bezár" icon={"pi pi-check"} loading={loading}
                      onClick={() => {
                        props = {...props, closeForm: true}
                      }}
                      className="p-button-success"/>
              <Button type="submit" label="Mentés" icon={"pi pi-check"} loading={loading}
                      onClick={() => {
                        props = {...props, closeForm: false}
                      }}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </Panel>
        {formData && formData.id &&
        <>
          <Panel headerTemplate={
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <h3>
                  <i className={"pi pi-list"}></i> Műveletek
                </h3>
              </div>
            </div>
          } className={"p-mt-3"}>
            <WorkflowactionListComponent />
          </Panel>
        </>
        }
      </form>
    )}/>
  )
}
export default withTranslation('common')(WorkflowFormComponent);
